"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metricValue_1 = require("../features/metricValue");
var status_1 = require("../features/status");
var threshold_1 = require("../features/threshold");
var FeatureFlags_1 = require("./FeatureFlags");
exports.buildCardAccessors = function (definition, featureFlags) {
    var _a;
    var refLineEnabled = (_a = featureFlags[FeatureFlags_1.CONSTANT_COMPARISONS_FLAG], (_a !== null && _a !== void 0 ? _a : true));
    var measureAccessor = metricValue_1.buildMeasureAccessor(definition);
    var timestampAccessor = metricValue_1.buildTimestampAccessor(definition);
    var comparisonAccessor = refLineEnabled ? threshold_1.buildFirstThresholdMeasureAccessor(definition) : undefined;
    var accessors = { measureAccessor: measureAccessor, timestampAccessor: timestampAccessor, comparisonAccessor: comparisonAccessor };
    return accessors;
};
function buildCardColors(definition, latestValue, featureFlags) {
    var _a;
    var colorIndicatorsEnabled = featureFlags[FeatureFlags_1.COLOR_INDICATORS_FLAG];
    var colorAccessor = status_1.buildColorAccessor(definition);
    var colorForPoint = (_a = (latestValue && colorAccessor(latestValue)), (_a !== null && _a !== void 0 ? _a : status_1.MetricsNeutralColor));
    var dotColor = colorIndicatorsEnabled ? colorForPoint : status_1.MetricsNeutralColor;
    var deltaColor = colorIndicatorsEnabled ? colorForPoint : status_1.MetricsGrey;
    var lineColor = colorIndicatorsEnabled ? status_1.MetricsGrey : status_1.MetricsNeutralColor;
    return { deltaColor: deltaColor, dotColor: dotColor, lineColor: lineColor };
}
exports.buildCardColors = buildCardColors;
//# sourceMappingURL=CardModel.js.map